import types from './types';

const INITIAL_STATE = {
  loading: false,
  list: [],
  loadingDetail: false,
  item: {},
  groceryList: [],
  loadingList: false,
  deliveryStatusesList: [],
  deliveryStatusLoading: false,
  refundLoading: false,
  detail: null,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.PRODUCT_ORDERS_LOAD:
      return { ...state, loading: action.payload };
    case types.PRODUCT_ORDERS_FETCHED:
      return { ...state, loading: false, list: action.payload };
    case types.PRODUCT_ORDERS_DETAIL:
      return { ...state, loading: false, detail: action.payload };
    case types.PRODUCT_BUTTON_LOADING:
      return { ...state, loading: action.payload };
    case types.PRODUCT_DETAIL_LOAD:
      return { ...state, loadingDetail: action.payload };
    case types.PRODUCT_DETAIL_FETCHED:
      return { ...state, loadingDetail: false, item: action.payload };
    case types.PRODUCT_GROCERY_LIST_LOAD:
      return { ...state, loadingList: action.payload };
    case types.PRODUCT_GROCERY_LIST_FETCHED:
      return { ...state, loadingList: false, groceryList: action.payload };
    case types.DELIVERY_STATUSES_FETCHED:
      return {
        ...state,
        deliveryStatusLoading: false,
        deliveryStatusesList: action.payload,
      };
    case types.DELIVERY_STATUSES_LOAD:
      return {
        ...state,
        deliveryStatusLoading: action.payload,
      };
    case types.PRODUCT_ORDERS_REFUND_LOAD:
      return { ...state, refundLoading: action.payload };
    default:
      return state;
  }
};
